import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=56cfb89f&"
import script from "./RequestItem.vue?vue&type=script&lang=js&"
export * from "./RequestItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=56cfb89f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports